import React from 'react';
import { componentService } from 'js/services/component.service';

export const FreeSpins = React.lazy(() => import(/* webpackChunkName: "free-spins" */ './FreeSpins'));

// <hub2-free-spins></hub2-free-spins>
componentService.registerWebContentComponents({ FreeSpins });
